import { ReportErrorsService } from './report-errors.service';

export default angular
  .module('sfMobile.services.reportErrors', [
    'sfMobile.services.forms',
    'sfMobile.services.reportQuestions',
    'sfMobile.constants.question-product',
  ])
  .factory('ReportErrorsService', ReportErrorsService).name;
